export enum CLAIM_DEVICE_ERRORS {
  ALREADY_CLAIMED = 'AlreadyClaimed',
  BAD_DEVICE_DATA = 'Device not found in inventory.',
}
